import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-user.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const UserIcon = createSvgIcon(<Icon />, 'UserIcon');
